module.exports = __webpack_public_path__ + "static/img/bazaar.7048200.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/bazaar.png
// module id = +vTn
// module chunks = 1